export type ArticleCategory =
  | "Buying a home"
  | "Remortgaging"
  | "Buy-to-let"
  | "Tools"
  | "News"
  | "Mortgage 101s";

export type CategoryTagColour = "purple" | "green" | "blue" | "gray" | "red" | "yellow";

export const CategoryToColourMap: Record<ArticleCategory, CategoryTagColour> = {
  "Buying a home": "blue",
  Remortgaging: "purple",
  "Buy-to-let": "green",
  Tools: "gray",
  News: "red",
  "Mortgage 101s": "yellow"
};

export enum ISplashPanelVariants {
  ORIGINAL = "original",
  SUNSET = "sunset",
  BOX_BUTTONS = "boxButtons",
  HORIZONTAL_BOX_BUTTONS = "horizontalBoxButtons",
  LIST_OF_ARTICLES = "listOfArticles",
  ARTICLE_SEARCH = "articleSearch",
  RATE_WATCH = "rateWatch",
  IMPORTANT_INFO = "importantInfo",
  WHAT_WE_OFFER = "whatWeOffer"
}

export enum ISplashPanelPresets {
  DEFAULT = "default",
  LIGHT_GREEN = "light-green",
  YELLOW = "yellow",
  LIGHT_PURPLE = "light-purple",
  DARK_PURPLE = "dark-purple"
}

export enum IPullOutBlocksVariants {
  ORIGINAL = "original",
  BETTER_V2_CARDS = "betterV2Cards",
  LITE = "lite",
  CARDS_WITH_OVERLAY = "cardsWithOverlay",
  BETTERV2 = "betterV2"
}

export enum IHorizontalCardsPanelVariants {
  HORIZONTAL = "horizontal",
  QUADRANT = "quadrant",
  YELLOW = "yellow",
  GREEN = "green",
  PURPLE = "purple"
}

export enum EVersions {
  V1 = "v1",
  V2 = "v2"
}

export interface ITextCard {
  title: string;
  body: {
    body: string;
  };
  headingType?: string;
  badgeText?: string;
  betterV2?: boolean;
}

export interface StringObject {
  [key: string]: string;
}

enum SignupJourneyToken {
  // eslint-disable-next-line max-len
  PURCHASE = "eyJwcm9wZXJ0eURldGFpbHMiOnsib2NjdXBhdGlvblN0YXR1cyI6Ik1BSU5fUkVTSURFTkNFIiwib2ZmZXJBY2NlcHRlZCI6dHJ1ZX0sInB1cmNoYXNpbmdQdXJwb3NlIjoiUFVSQ0hBU0UiLCJwdXJjaGFzaW5nSW50ZW50Ijp7Im9mZmVyTWFkZSI6dHJ1ZSwib2ZmZXJTdGF0dXMiOiJBQ0NFUFRFRCJ9fQ",
  // eslint-disable-next-line max-len
  REMORTGAGE = "eyJwcm9wZXJ0eURldGFpbHMiOnsib2NjdXBhdGlvblN0YXR1cyI6Ik1BSU5fUkVTSURFTkNFIiwib2ZmZXJBY2NlcHRlZCI6dHJ1ZX0sInB1cmNoYXNpbmdQdXJwb3NlIjoiUkVNT1JUR0FHRSIsInB1cmNoYXNpbmdJbnRlbnQiOnsib2ZmZXJNYWRlIjp0cnVlLCJvZmZlclN0YXR1cyI6IkFDQ0VQVEVEIn19",
  // eslint-disable-next-line max-len
  AFFORDABILITY = "eyJwcm9wZXJ0eURldGFpbHMiOnsib2NjdXBhdGlvblN0YXR1cyI6Ik1BSU5fUkVTSURFTkNFIiwib2ZmZXJBY2NlcHRlZCI6ZmFsc2V9LCJwdXJjaGFzaW5nUHVycG9zZSI6IlBVUkNIQVNFIiwicHVyY2hhc2luZ0ludGVudCI6eyJvZmZlck1hZGUiOnRydWUsIm9mZmVyU3RhdHVzIjoiQUNDRVBURUQifX0="
}

export const SignupURL = {
  PURCHASE: `/signup?application=${SignupJourneyToken.PURCHASE}`,
  REMORTGAGE: `/signup?application=${SignupJourneyToken.REMORTGAGE}`,
  AFFORDABILITY: `/signup?application=${SignupJourneyToken.AFFORDABILITY}`
};

export const SignupURLV2 = {
  PURCHASE: "/signup/purchase-offer-made",
  REMORTGAGE: "/signup/remortgage",
  AFFORDABILITY: "/signup/purchase-research"
};

export enum MortgagePurpose {
  Purchase = "purchase",
  PurchaseToLet = "purchase_to_let",
  Remo = "remo"
}

export enum HomeBuyingStage {
  Accepted = "accepted",
  Viewing = "viewing",
  Researching = "researching"
}

export enum NextSteps {
  Apply = "apply",
  Compare = "compare",
  MIP = "mip"
}

export enum AdditionalBorrowing {
  Yes = "yes",
  No = "no"
}
